/** @type {import('../help-index.js').HelpSidebarItem} */
export const ACC_LIB_DIARY_ITEM = {
  id: 'diary',
  screenId: 'acc-lib-diary',
  label: 'Diario',
  description: 'Libro diario cronológico de asientos.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Consultás todos los movimientos contables en orden de fecha: asiento, tipo, concepto, cuenta, debe y haber.',
      },
      {
        title: 'Paso 1 — Filtrar',
        fields: [
          { label: 'Desde / Hasta', description: 'Rango de fechas. Tocá «Consultar».' },
        ],
      },
      {
        title: 'Paso 2 — Resultados',
        bullets: [
          'Lista paginada; «Cargar más» si hay muchos registros.',
          'Descargar CSV o Excel con el mismo criterio de fechas.',
        ],
      },
    ],
  },
}
